<div class="unauthorized-layout">
  <!-- Global Language Switcher for Unauthorized Users -->
  <div class="global-language-switcher">
    <button 
      type="button" 
      class="lang-btn" 
      title="Change Language"
      (click)="toggleLanguage()"
      aria-label="Toggle Language">
      <i class="bi bi-globe"></i>
      <span class="lang-code">{{ currentLanguage }}</span>
    </button>
  </div>

  <!-- Content will be injected here (login, register, etc.) -->
  <ng-content></ng-content>
</div>
